module.exports = __webpack_public_path__ + "img/icons/slack-b56ff9e6ccddb2becee21bc21525b904.svg";